export default "__VITE_ASSET__D$vE0TKV__"